import { collection, addDoc, doc, setDoc, getDoc, DocumentReference, getDocs, deleteDoc} from "firebase/firestore";
import { auth, db } from "./firebase";
import { uploadFile } from "./googleCloudStorage";

export async function getFirestoreDoc(path) {
	try {
		const docRef = doc(db, path);
		const ret = await getDoc(docRef);
		return ret.data();	//should return undefined if document doesn't exist
	}
	catch (error) {
		return { error: error.message }; // Example error handling
	}
}

export async function setFirestoreDoc(path, data, id=null) {
	console.log('path', path, 'data', data)
	let docRef;
	if (id) {
		docRef = doc(db, path, id);
	}
	else {
		docRef = doc(db, path);
	}

// 	await setDoc(docRef, data, { merge: true }); // Use merge: true to update existing fields without overwriting the whole document
	try {
		await setDoc(docRef, data, { merge: true });
		return 0; // Return 0 for success
	} catch (error) {
		const errorMessage = error.message || 'An unknown error occurred';
		console.log('error', errorMessage);
		return { error: errorMessage }; // Return error message
	}
}

export async function deleteFirestoreDoc(path, id=null) {
	try {
		let docRef;
		if (id) {
			docRef = doc(db, path, id);
		} else {
			docRef = doc(db, path);
		}

		await deleteDoc(docRef);
		return 0; // Return 0 for success
	} catch (error) {
		const errorMessage = error.message || 'An unknown error occurred';
		return { error: errorMessage }; // Return error message
	}
}


export async function getFirestoreCollection(path) {
	const collectionRef = collection(db, path);
	const querySnapshot = await getDocs(collectionRef);
	const documents = querySnapshot.docs.map(doc => ({
		id: doc.id,
		...doc.data()
	}));
	return documents;
}

export async function getCase(caseID) {
	const uid = auth.currentUser.uid;
	const casePath = `/users/${uid}/cases/${caseID}`;
	const ret = await getFirestoreDoc(casePath);
	return ret;
} 

export async function setCase(caseID, caseData) {
	const uid = auth.currentUser.uid;
	const casePath = `/users/${uid}/cases/${caseID}`
	console.log('casePath', casePath, 'caseData', caseData);
	await setFirestoreDoc(casePath, caseData)
	const curUser = await getUser();
	const basicInfo = curUser?.basicInfo;
	const tmpBasicInfo = {...basicInfo}
	const caseBasicInfo = caseData?.basicInfo;

	Object.keys(caseBasicInfo).forEach(key => {
		if (caseBasicInfo[key] !== tmpBasicInfo[key]) {
			tmpBasicInfo[key] = caseBasicInfo[key];
		}
	});
	curUser.basicInfo = tmpBasicInfo;

	const address = curUser?.address;
	const tmpAddress = { ...address }
	const caseAddress = caseData?.address;
	Object.keys(caseAddress).forEach(key => {
		if (caseAddress[key] !== tmpAddress[key]) {
			tmpAddress[key] = caseAddress[key];
		}
	});
	curUser.address = tmpAddress;
	console.log("setCase, curUser", curUser);

	const r = await setUser(curUser);
	return r;
}

//Mostly you'll be using the functions in googleCloudStorage.js instead of these document functions. But they are included here for completeness. 

export async function getGlobalDocs() {
	const uid = auth.currentUser.uid;
	const docPath = `/documents/${uid}`;
	const ret = await getFirestoreDoc(docPath);
	return ret;
}

export async function setGlobalDocs(docs) {
	const uid = auth.currentUser.uid;
	const docPath = `/documents/${uid}`;
	setFirestoreDoc(docPath, docs);
}

export async function getUser() {
	try {
		const uid = auth.currentUser.uid;
		const userPath = `/users/${uid}`;
		const ret = await getFirestoreDoc(userPath);
		if (ret && ret.error) {
			throw new Error(ret.error); // Propagate error
		}
		return ret;
	} catch (error) {
		return { error: error.message }; // Return error condition
	}
}


export async function setUser(user) {
	const uid = auth.currentUser.uid;
	const userPath = `/users/${uid}`;
	const r = await setFirestoreDoc(userPath, user);
	return r;
}

export async function setPending(curCase) {
	const uid = auth.currentUser.uid;
	console.log('setPending caseID', curCase.id);
	const path = `/pending/cases/${uid}/${curCase.id}`;
	const data =  {
		curStatus: curCase?.curStatus,
		dateSubmitted: curCase?.dateSubmitted,
	}
	const r = await setFirestoreDoc(path, data);
	console.log('setPending return', r);
	return r;
}


export async function firestoreTest() {
	const jsonDatabase = db.toJSON()
	console.log('jsonDatabase', jsonDatabase)
  const docRef = await addDoc(collection(db, "documents"), {
    first: "Ada",
    last: "Lovelace",
    born: 1815
  });
}

export async function saveSignature(signature) {
	const uid = auth.currentUser.uid;
	const signaturePNG = signature.current.getTrimmedCanvas().toDataURL("image/png")
// 	const sigPath = `/users/${uid}/signatures/${Math.floor(Date.now() / 1000)}.png`;
	const sigPath = `/signatures/${uid}/${Math.floor(Date.now() / 1000)}.png`;
// 	setFirestoreDoc(sigPath, sigPath);
	uploadFile(signaturePNG, sigPath)
}
